<template>
  <div id="playground">
    <v-dialog
      v-model="selectedOpen"
      eager
      transition="dialog-bottom-transition"
      width="unset"
      offset-x
    >
      <v-card
        color="grey lighten-4"
        flat
      >
        <v-toolbar
          :color="selectedEvent.color"
          dark
        >
          <v-btn icon>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-toolbar-title>{{ selectedDay }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon>mdi-heart</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <h1>Signature</h1>
          <div id="VueSignaturePad">
            <VueSignaturePad
              ref="signaturePad"
              :custom-style="signatureStyle"
              height="200px"
            />
            <div>
              <v-btn
                text
                color="primary"
                @click="save"
              >
                Save
              </v-btn>
              <v-btn
                text
                color="secondary"
                @click="undo"
              >
                Undo
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div>
      <qrcode-scanner
        :qrbox="250"
        :fps="10"
        @result="onScan"
      />
      <br />
      <universal-input
        v-model="numericInputValue"
        :config="config"
      />
      <div>
        {{ debugMessage }}
      </div>
    </div>

    <universal-input
      v-model="orderType"
      :config="inputConfig"
    ></universal-input>
    <swipe-list
      ref="swipeListRef"
      class="card"
      :disabled="!enabled"
      :items="mockSwipeList"
      item-key="id"
      @swipeout:click="itemClick"
    >
      <template v-slot="{ item, index, revealLeft, revealRight, close }">
        <!-- item is the corresponding object from the array -->
        <!-- index is clearly the index -->
        <!-- revealLeft is method which toggles the left side -->
        <!-- revealRight is method which toggles the right side -->
        <!-- close is method which closes an opened side -->
        <div class="card-content">
          <!-- style content how ever you like -->
          <h2>{{ item.title }}</h2>
          <p>{{ item.description }}</p>
          <span>{{ index }}</span>
        </div>
      </template>
      <!-- right swipe side template and v-slot:right"{ item }" is the item clearly -->
      <!-- remove if you dont wanna have right swipe side  -->
      <template v-slot:right="{ item }">
        <div
          class="swipeout-action blue"
          @click="edit(item)"
        >
          <!-- place icon here or what ever you want -->
          <v-icon
            large
            color="white"
          >
            mdi-format-list-bulleted-square
          </v-icon>
        </div>
        <div
          class="swipeout-action red"
          @click="remove(item)"
        >
          <!-- place icon here or what ever you want -->
          <v-icon
            large
            color="white"
          >
            mdi-trash-can
          </v-icon>
        </div>
      </template>
      <template v-slot:empty>
        <div>
          <!-- change mockSwipeList to an empty array to see this slot in action  -->
          list is empty ( filtered or just empty )
        </div>
      </template>
    </swipe-list>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { SwipeList, SwipeOut } from 'vue-swipe-actions'
import UniversalInput from '@/components/CRUD/UniversalInput'
import QrcodeScanner from '@/components/QRCode/QrcodeScanner'
import UserList from '@/components/UserSelector/UserList'

import 'vue-swipe-actions/dist/vue-swipe-actions.css'

const enabled = ref(true)
const mockSwipeList = ref([
  {
    id: 0,
    title: 'Some title',
    description: 'some description',
  },
  {
    id: 1,
    title: 'Some title',
    description: 'some description',
  },
  {
    id: 2,
    title: 'Some title',
    description: 'some description',
  },
])
const swipeListRef = ref(null)
function revealFirstRight() {
  swipeListRef.value.revealRight(0)
}
function revealFirstLeft() {
  swipeListRef.value.revealLeft(0)
}
function closeFirst() {
  swipeListRef.value.closeActions(0)
}
function closeAll() {
  swipeListRef.value.closeActions()
}
function remove(item) {
  mockSwipeList.value = mockSwipeList.value.filter(i => i !== item)

  // console.log(e, 'remove');
}
function itemClick(e) {
  console.log(e, 'item click')
}
function fbClick(e) {
  console.log(e, 'First Button Click')
}
function sbClick(e) {
  console.log(e, 'Second Button Click')
}

const orderType = ref(1)
const inputConfig = ref(
  {
    propName: 'orderTypeID',
    label: 'Order Type',
    defaultValue: 1,
    type: {
      name: 'select',
      items: [{
        id: 1,
        label: 'abc',
      },
      {
        id: 2,
        label: 'abc2',
      },
      ],
      itemText: 'label',
    },
  },
)

// const calendar = ref(null)
const signaturePad = ref(null)

// onMounted(() => {
//   console.log('calendar', calendar)
//   calendar.value.scrollToTime('08:00')
// })
const today = ref(new Date().toISOString().substring(0, 10))
const events = ref([
  {
    name: 'Weekly Meeting',
    start: '2022-10-30 09:00',
    end: '2022-10-30 13:00',
  },
])

const date = new Date()
const year = date.getFullYear()
const month = date.getMonth()

const debugMessage = ref('')
const signatureStyle = ref({
  border: 'black 3px solid ',
})
const selectedDay = ref('')
const selectedOpen = ref(false)
const selectedElement = ref(null)
const selectedEvent = ref({})
const numericInputValue = ref(null)
const config = ref({
  propName: 'name',
  label: 'Dessert name',
  type: {
    inputType: 'number',
  },
})
const focus = ref('')

function showEvent(
  // { nativeEvent, event }
) {
  // console.log('showEvent', event)
  const open = () => {
    // this.selectedEvent = event
    // this.selectedElement = nativeEvent.target
    requestAnimationFrame(() => requestAnimationFrame(() => {
      selectedOpen.value = true
      nextTick(() => {
        signaturePad.value.resizeCanvas()
      })
    }))
  }

  if (selectedOpen.value) {
    selectedOpen.value = false
    requestAnimationFrame(() => requestAnimationFrame(() => open()))
  } else {
    open()
  }

  // nativeEvent.stopPropagation()
}
function onDayClick(day) {
  console.log(day)
  selectedDay.value = day.id
  showEvent()
}
function undo() {
  signaturePad.value.undoSignature()
}
function save() {
  const { isEmpty, data } = signaturePad.value.saveSignature()
  console.log(isEmpty)
  console.log(data)
}
function onScan(decodedText, decodedResult) {
  // handle the message here :)
  console.log('onScan decodedText, decodedResult', decodedText, decodedResult)
  alert(`scan result: ${decodedText}`)
}

</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';

.btn-toggle {
  flex-direction: column;
}
</style>
<style scoped>
.horizontal-list-container {
  display: inline-block;
  overflow-x: scroll;
  white-space: nowrap;
}

</style>
